import {
    useCreateBuildSettingsKeyMutation,
    useDeleteBuildSettingsKeyMutation,
    useGetBuildSettingsKeysQuery,
    useUpdateBuildSettingsKeyMutation
} from "@builder/store/slices/buildSettingsKeys/buildSettingsKeyApi";
import { useAppSelector } from "@builder/store/store";
import { skipToken } from "@reduxjs/toolkit/query";
import deepEqual from "fast-deep-equal";

const useSaveBuildSettingsKey = (): { isLoading: boolean; save: () => Promise<void> } => {
    const { id } = useAppSelector(state => state.builder.build);
    const companyId = useAppSelector(state => state.builder.build.companyId);
    const [createBuildSettingsKey, { isLoading: createLoading }] = useCreateBuildSettingsKeyMutation();
    const [updateBuildSettingsKey, { isLoading: updateLoading }] = useUpdateBuildSettingsKeyMutation();
    const [deleteBuildSettingsKey, { isLoading: deleteLoading }] = useDeleteBuildSettingsKeyMutation();
    const localBSK = useAppSelector(state => state.buildSettingsKey);
    const { data: dbBSK, isLoading: queryLoading } = useGetBuildSettingsKeysQuery(
        id && companyId ? { buildId: id, companyId: companyId } : skipToken
    );

    return {
        isLoading: queryLoading || createLoading || updateLoading || deleteLoading,
        save: async () => {
            if (!(queryLoading || createLoading || updateLoading || deleteLoading || !dbBSK || !companyId)) {
                const bskPromises: Promise<any>[] = [];
                for (const localKey in localBSK) {
                    if (dbBSK[localKey]) {
                        if (!deepEqual(localBSK[localKey], dbBSK[localKey])) {
                            bskPromises.push(
                                updateBuildSettingsKey({
                                    id: dbBSK[localKey]._id,
                                    buildSettingsKey: {
                                        label: localBSK[localKey].label || "",
                                        description: localBSK[localKey].description || "",
                                        placeholder: localBSK[localKey].placeholder || ""
                                    }
                                })
                            );
                        }
                    } else {
                        bskPromises.push(createBuildSettingsKey(localBSK[localKey]));
                    }
                }

                for (const dbKey in dbBSK) {
                    if (!localBSK[dbKey]) {
                        bskPromises.push(deleteBuildSettingsKey({ id: dbBSK[dbKey]._id, companyId: companyId }));
                    }
                }

                await Promise.all(bskPromises);
            }
        }
    };
};

export default useSaveBuildSettingsKey;
